import { create } from "zustand";
import { persist } from "zustand/middleware";

const useGlobalStore = create((set) => ({
  haveOpenPositions: false,
  setHaveOpenPositions: (value) =>
    set((state) => ({ ...state, haveOpenPositions: value })),

  indexPrices: {},
  setIndexPrices: (value) => set((state) => ({ ...state, indexPrices: value })),

  currentTradingIndex: {
    indexName: "nifty",
    indexLtp: "23578",
  },

  setCurrentTradingIndex: (value) =>
    set((state) => ({ ...state, currentTradingIndex: value })),

  selectedAccounts: [],
  setSelectedAccounts: (value) =>
    set((state) => ({ ...state, selectedAccounts: value })),

  accounts: [],
  setAccounts: (value) => set((state) => ({ ...state, accounts: value })),
}));

const useGlobalPersistentStore = create(
  persist(
    (set) => ({
      brokerLoginDetails: {
        clientCode: "",
        dhanApiKey: "",
      },
      loggedInUserDetails: {
        username: "",
      },
      setBrokerLoginDetails: (value) =>
        set((state) => ({ ...state, brokerLoginDetails: value })),
      setLoggedInUserDetails: (value) =>
        set((state) => ({ ...state, loggedInUserDetails: value })),
    }),
    { name: "global-store", getStorage: () => localStorage }
  )
);

export { useGlobalStore, useGlobalPersistentStore };
